import React from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@mui/material';
import useDialogStyles from '../useDialogStyles';
import ExitExistingDialogContent from './ExitExistingDialogContent';
import ExitNewDialogContent from './ExitNewDialogContent';

export function ExitConfirmationDialog({
  saving,
  savingDraft,
  isExitModalOpen,
  setIsExitModalOpen,
  editExistingJob,
  submit
}) {
  const classes = useDialogStyles();

  const close = () => setIsExitModalOpen(false);
  const saveDraft = () => submit('draft');

  return (
    <Dialog open={isExitModalOpen} onClose={close} classes={{ paper: classes.dialog }}>
      {editExistingJob ? (
        <ExitExistingDialogContent
          saving={saving}
          savingDraft={savingDraft}
          close={close}
          saveDraft={saveDraft}
        />
      ) : (
        <ExitNewDialogContent savingDraft={savingDraft} close={close} saveDraft={saveDraft} />
      )}
    </Dialog>
  );
}

ExitConfirmationDialog.propTypes = {
  saving: PropTypes.bool,
  savingDraft: PropTypes.bool,
  editExistingJob: PropTypes.bool,
  isExitModalOpen: PropTypes.bool,
  setActiveStep: PropTypes.func,
  setIsExitModalOpen: PropTypes.func,
  submit: PropTypes.func
};

export default ExitConfirmationDialog;
